import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicantReferencesKey,
  postApplicantReferencesRoute,
  errorMessage,
  SubmitReferenceData,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type UsePostApplicantReferenceProps = {
  applicantId?: number;
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const usePostApplicantReference = ({
  setErrorText,
  applicantId,
}: UsePostApplicantReferenceProps) => {
  const client = useQueryClient();

  const {
    mutate: postApplicantReference,
    isLoading: isPostApplicantReferenceLoading,
  } = useMutation({
    mutationFn: (variables: SubmitReferenceData) =>
      axiosInstance
        .post(postApplicantReferencesRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicantReferencesKey, applicantId]);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    postApplicantReference,
    isPostApplicantReferenceLoading,
  };
};
